import * as Types from '../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WholeSyncableDispensationFragment = { readonly __typename?: 'SyncableDispensation', readonly id: string, readonly dispensationStrategy: Types.DispensationStrategy, readonly dispensedByUserId: string, readonly facilityId: string, readonly locationId: string, readonly prescriptionId: string, readonly quantity?: number | null, readonly skuId?: string | null, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly createdByUserId: string, readonly deleted: boolean, readonly updatedAt: string, readonly updatedByUserId: string } };

export type SyncDispensationPushMutationVariables = Types.Exact<{
  input: Types.PushDispensationInput;
}>;


export type SyncDispensationPushMutation = { readonly __typename?: 'Mutation', readonly pushDispensation: { readonly __typename?: 'PushDispensationResponse', readonly rows: ReadonlyArray<{ readonly __typename?: 'SyncableDispensation', readonly id: string, readonly dispensationStrategy: Types.DispensationStrategy, readonly dispensedByUserId: string, readonly facilityId: string, readonly locationId: string, readonly prescriptionId: string, readonly quantity?: number | null, readonly skuId?: string | null, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly createdByUserId: string, readonly deleted: boolean, readonly updatedAt: string, readonly updatedByUserId: string } }> } };

export type SyncDispensationPullQueryVariables = Types.Exact<{
  input: Types.PullDispensationInput;
}>;


export type SyncDispensationPullQuery = { readonly __typename?: 'Query', readonly pullDispensation: { readonly __typename?: 'PullDispensationResponse', readonly checkpoint?: { readonly __typename?: 'SyncableCheckpoint', readonly id: string, readonly updatedAt: string } | null, readonly documents: ReadonlyArray<{ readonly __typename?: 'SyncableDispensation', readonly id: string, readonly dispensationStrategy: Types.DispensationStrategy, readonly dispensedByUserId: string, readonly facilityId: string, readonly locationId: string, readonly prescriptionId: string, readonly quantity?: number | null, readonly skuId?: string | null, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly createdByUserId: string, readonly deleted: boolean, readonly updatedAt: string, readonly updatedByUserId: string } }> } };

export const WholeSyncableDispensationFragmentDoc = gql`
    fragment WholeSyncableDispensation on SyncableDispensation {
  id
  dispensationStrategy
  dispensedByUserId
  facilityId
  locationId
  meta {
    createdAt
    createdByUserId
    deleted
    updatedAt
    updatedByUserId
  }
  prescriptionId
  quantity
  skuId
}
    `;
export const SyncDispensationPushDocument = gql`
    mutation SyncDispensationPush($input: PushDispensationInput!) {
  pushDispensation(input: $input) {
    rows {
      ...WholeSyncableDispensation
    }
  }
}
    ${WholeSyncableDispensationFragmentDoc}`;
export type SyncDispensationPushMutationFn = Apollo.MutationFunction<SyncDispensationPushMutation, SyncDispensationPushMutationVariables>;

/**
 * __useSyncDispensationPushMutation__
 *
 * To run a mutation, you first call `useSyncDispensationPushMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncDispensationPushMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncDispensationPushMutation, { data, loading, error }] = useSyncDispensationPushMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncDispensationPushMutation(baseOptions?: Apollo.MutationHookOptions<SyncDispensationPushMutation, SyncDispensationPushMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncDispensationPushMutation, SyncDispensationPushMutationVariables>(SyncDispensationPushDocument, options);
      }
export type SyncDispensationPushMutationHookResult = ReturnType<typeof useSyncDispensationPushMutation>;
export type SyncDispensationPushMutationResult = Apollo.MutationResult<SyncDispensationPushMutation>;
export type SyncDispensationPushMutationOptions = Apollo.BaseMutationOptions<SyncDispensationPushMutation, SyncDispensationPushMutationVariables>;
export const SyncDispensationPullDocument = gql`
    query SyncDispensationPull($input: PullDispensationInput!) {
  pullDispensation(input: $input) {
    checkpoint {
      id
      updatedAt
    }
    documents {
      ...WholeSyncableDispensation
    }
  }
}
    ${WholeSyncableDispensationFragmentDoc}`;

/**
 * __useSyncDispensationPullQuery__
 *
 * To run a query within a React component, call `useSyncDispensationPullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSyncDispensationPullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSyncDispensationPullQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncDispensationPullQuery(baseOptions: Apollo.QueryHookOptions<SyncDispensationPullQuery, SyncDispensationPullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SyncDispensationPullQuery, SyncDispensationPullQueryVariables>(SyncDispensationPullDocument, options);
      }
export function useSyncDispensationPullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SyncDispensationPullQuery, SyncDispensationPullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SyncDispensationPullQuery, SyncDispensationPullQueryVariables>(SyncDispensationPullDocument, options);
        }
export type SyncDispensationPullQueryHookResult = ReturnType<typeof useSyncDispensationPullQuery>;
export type SyncDispensationPullLazyQueryHookResult = ReturnType<typeof useSyncDispensationPullLazyQuery>;
export type SyncDispensationPullQueryResult = Apollo.QueryResult<SyncDispensationPullQuery, SyncDispensationPullQueryVariables>;